interface Page {
  path: string;
  name: string;
  showInNav: boolean;
  openInNewTab?: boolean;
}

export const PAGES: Record<string, Page> = {
  home: {
    path: '/',
    name: 'Home',
    showInNav: true,
  },
  menu: {
    path: '/menu',
    name: 'Menu',
    showInNav: true,
  },
  catering: {
    path: '/catering',
    name: 'Catering',
    showInNav: true,
    openInNewTab: true,
  },
  blog: {
    path: '/blog',
    name: 'Blog',
    showInNav: true,
  },
  schoolFundraisers: {
    path: '/school-fundraisers',
    name: 'School Fundraisers',
    showInNav: false,
  },
  schoolFundraiserBooking: {
    path: '/school-fundraisers/book',
    name: 'Book a School Fundraiser',
    showInNav: false,
    openInNewTab: true,
  },
  ourStory: {
    path: '/our-story',
    name: 'Our Story',
    showInNav: true,
  },
  press: {
    path: '/press',
    name: 'Press',
    showInNav: true,
  },
  contact: {
    path: '/contact',
    name: 'Contact',
    showInNav: true,
  },
  careers: {
    path: '/careers',
    name: 'Careers',
    showInNav: false,
  },
  orderOnline: {
    path: '/order-online',
    name: 'Order Online',
    showInNav: false,
  },
  orderOnlineTeaRekz: {
    path: '/order-online-tearekz',
    name: "Order Online - Tea Rek'z",
    showInNav: false,
    openInNewTab: true,
  },
  reservations: {
    path: '/reservations',
    name: 'Reservations',
    showInNav: false,
  },
  privacyPolicy: {
    path: '/policy/privacy',
    name: 'Privacy Policy',
    showInNav: false,
  },
  termsOfService: {
    path: '/policy/tos',
    name: 'Terms of Service',
    showInNav: false,
  },
  tvrekz: {
    path: '/tvrekz',
    name: "TV Rek'z",
    showInNav: false,
  },
  grabngoPrint: {
    path: '/menu/grabngo-print',
    name: 'Grab n Go Print',
    showInNav: false,
  },
} as const;

export const SITE_URL = 'https://skilletz.cafe';
